import { render, staticRenderFns } from "./businessOpportunityList.vue?vue&type=template&id=69976895&scoped=true"
import script from "./businessOpportunityList.vue?vue&type=script&lang=js"
export * from "./businessOpportunityList.vue?vue&type=script&lang=js"
import style0 from "./businessOpportunityList.vue?vue&type=style&index=0&id=69976895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69976895",
  null
  
)

export default component.exports